module.exports = __webpack_public_path__ + "static/media/spotify-logo.a77127f4.svg";